import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPassportData } from "../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import FinListPassportRenwal from "./FinListPassportRenewal";
import nodeinstance from "../../../../nodeInstance";

export default function FinPassportRenewal() {
  const data = useSelector((state) => state.passportData);
  const dispatch = useDispatch();

  //screen Title Show fun
  const titleBorder = [
    { label: "Passport Renewal", link: "/dashboard/FinAtmPayroll" },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  // useEffect(() => {
  //     dispatch(getPassportData(token));
  // }, []);

  const [responseData, setResponseData] = useState([]);
  const getPassportData = async () => {
    try {
      const response = await nodeinstance.get(
        `/passport-renewal/pendingPayment`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setResponseData(response.data);
      }
    } catch (error) {
      console.log("error to be seen in the console", error);
    }
  };

  useEffect(() => {
    getPassportData();
  }, []);
  const updateData = () => {
    // dispatch(getPassportData(token));
    getPassportData();
  };

  return (
    <>
      <div className={`ml-5 mr-5`}>
        <FinListPassportRenwal
          list={responseData}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE NAME",
            "CLIENT",
            "IQAMA NUMBER",
            "PASSPORT NUMBER",
            "PASSPORT EXPIRY",
            "PASSPORT ISSUE DATE",
            "NATIONALITY",
            "BORNE BY",
            "RENWAL FEE",
            "status",
            "Action",
          ]}
          token={token}
          updateData={updateData}
        />
      </div>
    </>
  );
}
